import App from "./App.svelte";
export const OtterMeetingCostCalculator = (targetId, config) => {
    const app = new App({
        target: document.getElementById(targetId),
        props: {
            options: config,
        },
    });
    return app;
};
window.OtterMeetingCostCalculator = OtterMeetingCostCalculator;
export default OtterMeetingCostCalculator;
